import { Flex } from '@chakra-ui/react';
import { TitleBar } from '@resistapp/client/components/bars/title-bar';
import { ChartGroupContainer } from '@resistapp/client/components/plots/containers/chart-group-container';
import { LoadingView } from '@resistapp/client/components/states/loading';

import { useParams } from 'react-router-dom';
import { ChipViewCharts } from './chip-view-charts';
import { ChipViewLegends } from './chip-view-legends';
import { ChipInfoAndLinksSection } from './info-and-link-section';
import { ChipContextProvider, useChipContext } from './use-chip-context';

function ChipViewInner() {
  const { loading, chipInfo } = useChipContext();
  const { chipId } = useParams();

  if (loading) {
    return <LoadingView />;
  }

  return (
    <>
      <TitleBar title={<span>{chipInfo ? `Chip ${chipInfo.name}` : `Chip ${chipId}`}</span>} />
      <ChartGroupContainer style={{ paddingTop: '25px', paddingBottom: '30px' }}>
        <Flex gap={4} alignItems="flex-start" wrap="nowrap">
          <ChipViewLegends />
          <ChipViewCharts />
        </Flex>
      </ChartGroupContainer>
      {chipInfo && <ChipInfoAndLinksSection />}
    </>
  );
}

export function ChipView() {
  return (
    <ChipContextProvider>
      <ChipViewInner />
    </ChipContextProvider>
  );
}
